import type {EventHandler, EventType} from "../index";
import {OrderFoundEvent} from "../index";
import store from "../../../configureStore";
import {DMS_ORDER_GET_BY_ID} from "../../action";

export const OrderFoundEventHandler: EventHandler = {
	handles(eventType: EventType): boolean {
		return eventType === "ORDER_FOUND";
	},
	handle(event: OrderFoundEvent) {
		store.dispatch({
			type: DMS_ORDER_GET_BY_ID.SUCCESS,
			payload: {
				orderNumber: event.orderId,
				createdAt: event.createdAt,
				customer: {
					customerNumber: event.customer.customerNumber,
					salutation: event.customer.salutation,
					firstName: event.customer.firstName,
					lastName: event.customer.lastName,
					city: event.customer.city,
					street: event.customer.street,
					zipCode: event.customer.zipCode,
					mobile: event.customer.mobile,
					phone: event.customer.phone,
					email: event.customer.email,
					country: event.customer.country,
				},
				vehicle: {
					customer: event.vehicle.customer,
					mileage: event.vehicle.mileage,
					vin: event.vehicle.vin,
					manufacturerCodeNumber: event.vehicle.manufacturerCodeNumber,
					typeCodeNumber: event.vehicle.typeCodeNumber,
					licensePlate: event.vehicle.licensePlate,
					emissionCode: event.vehicle.emissionCode,
					mainInspectionDate: event.vehicle.mainInspectionDate,
				},
				parts: event.parts?.map(part => {
					return {
						partNumber: part.partNumber,
						quantity: part.quantity,
					};
				}),
				state: event.status
			}
		});
	}
};
